import { Typography } from '@mui/material';
import React from 'react';

interface CellHilTemplateGeneratedTypeProps {
  params: any;
}

const CellHilTemplateGeneratedType = ({
  params,
}: CellHilTemplateGeneratedTypeProps) => {
  const value = String(
    params?.row?.generated_type ?? params?.row?.type ?? '',
  );

  return (
    <Typography
      variant="body2"
      color="text.primary"
      sx={{
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '100%',
      }}
    >
      {value}
    </Typography>
  );
};

export default CellHilTemplateGeneratedType;
